import CoverInfo from './CoverInfo';

export default CoverInfo;
